import React, { useEffect, useRef, useState } from 'react';
import { ToastContext } from './Webform/context';
import { Toast } from 'bootstrap';
import { CheckCircle, X, XCircle } from 'react-feather';

function Toastbox({ children }) {
    const ref = useRef(null);
    const instance = useRef(null);
    const [body, setBody] = useState('');
    const [title, setTitle] = useState('');
    const [variant, setVariant] = useState('');
    const [placement, setPlacement] = useState('top-0 end-0');
    const [html, setHtml] = useState('');

    function showToast({
        title: newTitle,
        message: newMessage,
        variant: newVariant,
        placement: newPlacement,
        html: newHtml
    }) {
        // clear all toasts created from rails to avoid said toasts from unnessesarily showing up
        const existingToasts = document.querySelectorAll('.js-rails-toasts');
        if (Boolean(existingToasts.length)) {
            existingToasts.forEach(function(el) {
                el.remove();
            });
        }

        let placementClass = (newPlacement || "top-right").split("-")
                                .map(loc => {
                                    if (loc === "bottom") return "bottom-0";
                                    if (loc === "top") return "top-0";
                                    if (loc === "left") return "start-0";
                                    if (loc === "right") return "end-0";
                                    return null;
                                }).join(" ");

        setTitle(newTitle);
        setBody(newMessage);
        setVariant(newVariant);
        setPlacement(placementClass);
        setHtml(newHtml);
        instance.current?.show();

        const toasts = document.querySelectorAll('.toast');
        if (Boolean(toasts.length)) {
            toasts.forEach(function(el) {
                new window.Toast(el).show();
            });
        }
    }

    function hideToast() {
        instance.current?.hide();
        setTitle('');
        setBody('');
        setVariant('');
    }

    useEffect(() => {
        const el = Toast.getOrCreateInstance(ref?.current);
        instance.current = el;
    }, [body]);

    const darkColor = variant === "success" ? "dark-green" : "dark-red";
    const bgColor = variant === "success" ? "success" : "danger" 
    const containerClass = [
        "toast",
        "ps-4 pe-2",
        "border-start border-top-0 border-end-0 border-bottom-0  border-5",
        `bg-${bgColor}-soft border-${darkColor}`,
    ].join(" ");

    return (
        <ToastContext.Provider value={{ showToast, hideToast }}>
            {children}
            <div className={`toast-container position-fixed ${placement} p-3 zindex-tooltip`}>
                <div
                    className={containerClass}
                    role="alert"
                    aria-live="assertive"
                    aria-atomic="true"
                    data-bs-autohide="true"
                    ref={ref}
                    style={{ minWidth: "430px" }}
                >
                    <div className="d-flex gap-4">
                        {variant === "success" ? (
                            <CheckCircle size={38} className="text-dark-green align-self-center" />
                        ) : null}
                        {variant === "error" ? (
                            <XCircle size={38} className="text-dark-red align-self-center" />
                        ) : null}
                        <div className="d-flex py-4 flex-column text-start w-100">
                            <strong>{title}</strong>
                            <small>{body}</small>
                            {!!html && (
                                <div dangerouslySetInnerHTML={{ __html: html }} />
                            )}
                        </div>
                        <div>
                            <button
                                type="button"
                                className={`ms-auto pt-3 align-self-top btn btn-sm text-${darkColor}`}
                                data-bs-dismiss="toast"
                                aria-label="Close"
                                onClick={hideToast}>
                                <X />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </ToastContext.Provider>
    );
}

export default Toastbox;
